import Vue from 'vue';
import Router from 'vue-router';
import store from './vuex/vuex';
import Cookies from 'js-cookie';
import Config from '@/config';
import { handleByPermission } from './permissions';
import { maintenanceTimer } from './lib/tools';

// Layouts
import DefaultLayout from './layouts/DefaultLayout';
import LoginLayout from './layouts/LoginLayout';

// Login pages
import LoginForm from './pages/Login/LoginForm';
import PasswordForm from './pages/Login/ChangePassword/Wrapper';
import SamlLogin from './pages/SamlLogin';
import TempLogin from './layouts/TempLoginLayout';
import RippleLogin from './pages/Ripple/Login';
import Maintenance from './pages/Login/Maintenance';

// Error pages
import NotFound from './pages/Errors/404.vue';
import InternalServerError from './pages/Errors/500.vue';

// Dashboard page
import PageDashboard from './pages/Dashboard/Dashboard';

// Announcements page
import Announcements from './pages/Announcements';

// Report Filters page
import ReportFilters from './pages/ReportFilters';
import CreateReportFilters from './pages/ReportFilters/FilterForm';
import EditReportFilters from './pages/ReportFilters/FilterForm';

// Usage Reports page
import UsageReports from './pages/UsageReport';
import AccountList from './pages/UsageReport/SideList/ListAccount';
import AzureSubscriptionList from './pages/UsageReport/SideList/ListAzureSubscription';
import CrossTagList from './pages/UsageReport/SideList/ListCrossTag';
import GroupList from './pages/UsageReport/SideList/ListGroup';
import ReportFilterList from './pages/UsageReport/SideList/ListReportFilter';
import BudgetSetting from './pages/UsageReport/BudgetSetting';
import MainView from './pages/UsageReport/MainView';
import BlankView from '@/pages/UsageReport/BlankView';

// Setting page
import PageSettings from './pages/Preferences/Preferences';

import { analyzer } from '@/analyzer';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH || '/wavepro/',
  routes: [
    // Errors
    { path: '*', name: 'notFound', component: NotFound },
    { path: '/500', name: 'internalServerError', component: InternalServerError },

    {
      path: '/login',
      component: !maintenanceTimer() ? LoginLayout : Maintenance,
      meta: { requiresAuth: false },
      children: [
        {
          path: '',
          components: {
            content: LoginForm,
          },
        },
        {
          path: '/change-password',
          components: {
            content: PasswordForm,
          },
          // flagIdsAnyOf: ['0bdb5b9d-9b2f-4e6c-98e8-422fae369b8d'],
        },
      ],
    },

    {
      path: '/saml',
      component: !maintenanceTimer() ? LoginLayout : Maintenance,
      meta: { requiresAuth: false },
      children: [
        {
          path: '',
          components: {
            content: SamlLogin,
          },
        },
      ],
    },

    {
      path: '/EAZFMpmpLQiqj47DR3ztAMUjpHYZJC',
      component: TempLogin,
      meta: { requiresAuth: false },
      children: [
        {
          path: '',
          components: {
            content: LoginForm,
          },
        },
        {
          path: '/change-password',
          components: {
            content: PasswordForm,
          },
          // flagIdsAnyOf: ['0bdb5b9d-9b2f-4e6c-98e8-422fae369b8d'],
        },
      ],
    },
    {
      path: '/ripple/login',
      component: RippleLogin,
      meta: { requiresAuth: false },
    },
    {
      path: '/',
      component: DefaultLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          redirect: '/dashboard',
        },
        {
          path: 'dashboard',
          components: {
            contents: PageDashboard,
          },
        },
        {
          path: 'announcements',
          name: 'Announcements',
          components: {
            contents: Announcements,
          },
        },
        {
          path: 'report_filters/create',
          name: 'CreateReportFilters',
          components: {
            contents: CreateReportFilters,
          },
        },
        {
          path: 'report_filters/edit/:id',
          name: 'EditReportFilters',
          components: {
            contents: EditReportFilters,
          },
        },
        {
          path: 'report_filters/:activeFilter?',
          name: 'ReportFilters',
          components: {
            contents: ReportFilters,
          },
        },
        {
          path: 'usage_reports',
          components: {
            contents: UsageReports,
          },
          children: [
            {
              path: 'account',
              components: { side_list: AccountList, contents: BlankView },
              meta: { group_by: 'account' },
            },
            {
              path: 'account/:id',
              components: { side_list: AccountList, contents: MainView },
              meta: { group_by: 'account' },
            },
            {
              path: 'account/:id/budget',
              components: { side_list: AccountList, contents: BudgetSetting },
              meta: { group_by: 'account' },
            },
            {
              path: 'azure_subscription',
              components: { side_list: AzureSubscriptionList, contents: BlankView },
              meta: { group_by: 'azure_subscription' },
            },
            {
              path: 'azure_subscription/:id',
              components: { side_list: AzureSubscriptionList, contents: MainView },
              meta: { group_by: 'azure_subscription' },
            },
            {
              path: 'group',
              components: { side_list: GroupList, contents: BlankView },
              meta: { group_by: 'acc_group' },
            },
            {
              path: 'group/:id',
              components: { side_list: GroupList, contents: MainView },
              meta: { group_by: 'acc_group' },
            },
            {
              path: 'group/:id/budget',
              components: { side_list: GroupList, contents: BudgetSetting },
              meta: { group_by: 'acc_group' },
            },
            {
              path: 'cross_tag',
              components: { side_list: CrossTagList, contents: BlankView },
              meta: { group_by: 'cross_tag' },
            },
            {
              path: 'cross_tag/:id',
              components: { side_list: CrossTagList, contents: MainView },
              meta: { group_by: 'cross_tag' },
            },
            {
              path: 'report_filter',
              components: { side_list: ReportFilterList, contents: BlankView },
              meta: { group_by: 'report_filter' },
            },
            {
              path: 'report_filter/:id',
              components: { side_list: ReportFilterList, contents: MainView },
              meta: { group_by: 'report_filter' },
            },
          ],
        },
        {
          path: 'preferences',
          name: 'Preferences',
          components: {
            contents: PageSettings,
          },
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  analyzer.track('SelectMenu: ' + to['path'], { userpass: to['path'] });

  if (to.path === '/' && to.query.redirect) {
    next(to.query.redirect);
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    const resellerToken = Cookies.get('mo_wave_for_reseller_access_token', {
      path: Config.cookiePath,
    });
    const accessToken = Cookies.get('mo_access_token', { path: Config.cookiePath });

    // アクセストークンが無い場合
    if (!accessToken) {
      // リセラートークンがあれば NEXT
      if (resellerToken) next();
      else
        next({
          path: '/login',
          query: { redirect: to.fullPath },
        });
    } else {
      if (to.meta.handleDisplay) {
        const userMeta = store.state.userState.meta[to.meta.handleDisplay];
        if (userMeta) {
          next();
        } else {
          next({ path: '/404' });
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

router.afterEach(to => {
  if (to['path'] === '/usage_reports' || to['path'] === '/usage_reports/') {
    if (handleByPermission('/usage_reports/account')) {
      return router.push('/usage_reports/account').catch(() => {});
    } else if (handleByPermission('/usage_reports/group')) {
      return router.push('/usage_reports/group').catch(() => {});
    } else if (handleByPermission('/usage_reports/tag')) {
      return router.push('/usage_reports/tag').catch(() => {});
    } else if (handleByPermission('/usage_reports/azure_subscription')) {
      return router.push('/usage_reports/azure_subscription').catch(() => {});
    } else {
      return router.push('/dashboard').catch(() => {});
    }
  }

  if (store.state.rootUser) return false;

  if (!handleByPermission(to['path'])) {
    router.push('/dashboard').catch(() => {});
  }
});

export default router;
